import { MediaContentMediaType } from '@apis/common/response';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface EventProperties {
  properties: any;
  setProperties: (value) => void;
}
export const useEventPropertiesStore = create<EventProperties>((set) => ({
  properties: { url: '', path: '' },
  setProperties: (value) => set({ properties: value }),
}));

interface WindowPosition {
  xPercent: number;
  yPercent: number;
}

interface WindowSize {
  width: number;
  height: number;
}

interface WindowMediaInfo {
  key: string;
  title?: string;
  open: boolean;
  url: string;
  type: MediaContentMediaType;
  position: WindowPosition;
  size: WindowSize;
}

interface MediaWindowStore {
  mediaInfoList: WindowMediaInfo[];
  openMediaInfo?: (
    key: string,
    title: string,
    url: string,
    mediaType: MediaContentMediaType,
  ) => void;
  saveWindowPosition?: (key: string, value: WindowPosition) => void;
  saveWindowSize?: (key: string, value: WindowSize) => void;
  hideMediaWindow?: (key: string) => void;
}

export const useMediaWindowInfoStore = create(
  persist<MediaWindowStore>(
    (set) => ({
      mediaInfoList: [],
      openMediaInfo: (
        key: string,
        title: string,
        url: string,
        mediaType: MediaContentMediaType,
      ) =>
        set((prev) => {
          if (prev.mediaInfoList.some((media) => media.key === key)) {
            return {
              mediaInfoList: prev.mediaInfoList.map((media) =>
                media.key === key
                  ? { ...media, open: true, url: url, title: title }
                  : media,
              ),
            };
          } else {
            return {
              mediaInfoList: [
                ...prev.mediaInfoList,
                {
                  key: key,
                  url: url,
                  open: true,
                  title: title,
                  type: mediaType,
                  position: null,
                  size: {
                    width: 640,
                    height: 560,
                  },
                },
              ],
            };
          }
        }),
      saveWindowPosition: (key: string, value: WindowPosition) =>
        set((prev) => ({
          mediaInfoList: prev.mediaInfoList.map((media) =>
            media.key === key ? { ...media, position: value } : media,
          ),
        })),
      saveWindowSize: (key: string, value: WindowSize) =>
        set((prev) => ({
          mediaInfoList: prev.mediaInfoList.map((media) =>
            media.key === key ? { ...media, size: value } : media,
          ),
        })),
      hideMediaWindow: (key: string) => {
        set((prev) => ({
          mediaInfoList: prev.mediaInfoList.map((media) =>
            media.key === key ? { ...media, open: false, url: null } : media,
          ),
        }));
      },
    }),
    {
      name: 'media-window-storage',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ mediaInfoList: state.mediaInfoList }),
    },
  ),
);
